/** « Codes ignorés » (menu « Plus ») : réactiver un code ou tous. */
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { reactivateAllCodes, reactivateCode, useIgnoredCodes } from '@/features/stock-mode';

export function IgnoredCodesDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const codes = useIgnoredCodes();
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
      <DialogContent
        className="flex max-h-[90vh] flex-col sm:max-w-md"
        data-testid="ignored-codes"
        onCloseAutoFocus={(event) => event.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Codes ignorés</DialogTitle>
          <DialogDescription>
            Leur scan ne fait rien jusqu'à la déconnexion. Réactivez-les pour les traiter.
          </DialogDescription>
        </DialogHeader>
        {codes.length === 0 ? (
          <p className="py-6 text-center text-base text-muted-foreground">Aucun code ignoré</p>
        ) : (
          <>
            <ul className="min-h-0 flex-1 divide-y divide-border overflow-y-auto rounded-lg border border-border">
              {codes.map((code) => (
                <li key={code} className="flex items-center gap-2 p-2">
                  <span className="min-w-0 flex-1 break-all font-mono text-base">{code}</span>
                  <Button
                    variant="outline"
                    className="h-12 shrink-0"
                    aria-label={`Réactiver ${code}`}
                    onClick={() => reactivateCode(code)}
                  >
                    Réactiver
                  </Button>
                </li>
              ))}
            </ul>
            <Button variant="outline" className="h-12 w-full" onClick={reactivateAllCodes}>
              Tout réactiver
            </Button>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
